module.exports = __webpack_public_path__ + "static/media/drag-file-icon.e9fd5b8b.svg";